import { IAddressContainer } from '@mt-ng2/dynamic-form';

export class AddressContainer {
    static getNew(): IAddressContainer {
        return {
            Address: {
                Address1: '',
                Address2: '',
                City: '',
                CountryCode: 'US',
                Id: 0,
                Province: '',
                StateCode: '',
                Zip: '',
            },
            AddressId: 0,
            IsPrimary: false,
        };
    }
}
